module.exports = __webpack_public_path__ + "img/mood_rolleyes.73b07f9c.png";